import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { REFERENCIALS_URL, useGetReferentialsAsync } from '@/features/shared/apis';

import { GetCountriesReferentialResponse } from '../types';

export const useCountriesOptions = () => {
  const { t } = useTranslation('countries');

  const { data: countriesReferentialData, isLoading: isCountriesReferentialLoading } =
    useGetReferentialsAsync<GetCountriesReferentialResponse>(REFERENCIALS_URL.COUNTRY_CODE);

  const countriesOptions = useMemo(() => {
    const data = (countriesReferentialData?.countryCodeList ?? [])
      .sort((countryA, countryB) => countryA?.countryCode?.localeCompare(countryB?.countryCode))
      .map(({ countryCode }) => ({
        label: t(`COUNTRY_CODE_${countryCode}`),
        value: countryCode,
      }));

    return data;
  }, [countriesReferentialData?.countryCodeList, t]);

  return {
    isCountriesReferentialLoading,
    countriesOptions,
  };
};
